import { useQuery } from 'react-query';
import { ClientGoalsListResponse, model as clientGoalsModel } from '../goals';

export const queryKey = (clientId: string) => ['client', `${clientId}`, 'goals'];

export const useClientGoalsList = (clientId: string) =>
  useQuery<ClientGoalsListResponse>(queryKey(clientId), () => clientGoalsModel(clientId).getList());
